import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { TableConfig } from "@app/shared/util/table-config.utils";
import { FormBuilder, FormGroup } from "@angular/forms";
import { BottomSheetComponent } from "@components/bottom-sheet/bottom-sheet.component";
import { Line } from "@models/line.model";

@Component({
    selector: 'app-tool-processing-filter-bottom-sheet',
    templateUrl: './tool-processing-filter-bottom-sheet.component.html',
    styleUrls: ['./tool-processing-filter-bottom-sheet.component.scss']
})
export class ToolProcessingFilterBottomSheetComponent implements OnInit, OnChanges {
    @ViewChild(BottomSheetComponent, {static: false}) bottomSheet: any;

    @Input() config: TableConfig;
    @Input() availableStatuses = [];
    @Input() availableTypes = [];
    @Input() availableLines: Line[];

    @Output() apply = new EventEmitter<TableConfig>();

    filterForm: FormGroup;

    constructor(private fb: FormBuilder) {
        this.filterForm = this.fb.group({
            status: [null], // Default value for status
            type: [null],   // Default value for type
            lineId: [null]    // Default value for line
        });
    }

    ngOnInit(): void {
        this.computeSelectedFilters();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.config) {
            this.computeSelectedFilters();
        }
    }

    computeSelectedFilters(): void {
        if (this.config && this.config.filters) {
            this.config.filters.forEach(filter => {
                if (this.filterForm.controls[filter.field]) {
                    this.filterForm.patchValue({[filter.field]: filter.value});
                }
            });
        }
    }

    open(): void {
        this.bottomSheet.open();
    }

    close(): void {
        this.bottomSheet.close();
    }

    toggle(): void {
        this.bottomSheet.toggle();
    }

    onBack(): void {
        this.close();
    }

    onApply(): void {
        const selectedStatus = this.filterForm.get('status')?.value;
        const selectedType = this.filterForm.get('type')?.value;
        const selectedLine = this.filterForm.get('lineId')?.value;

        if (selectedStatus) {
            this.config.upsertFilter('status', selectedStatus);
        } else {
            this.config.removeFilter('status')
        }

        if (selectedType) {
            this.config.upsertFilter('type', selectedType);
        } else {
            this.config.removeFilter('type');
        }

        if (selectedLine) {
            this.config.upsertFilter('lineId', selectedLine);
        } else {
            this.config.removeFilter('lineId');
        }

        // Emit the updated config
        this.apply.emit(this.config);
    }

}
